import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { FabricDataflowLinkedService } from 'shell-models-lib';
import { Model } from '../../backendmodel';
import { LinkedServiceAdapter } from './linkedservice.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FabricDataflowLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {},
            parameters: '*'
        }
    }
})
export class FabricDataflowLinkedServiceAdapter extends LinkedServiceAdapter<FabricDataflowLinkedService> {

    protected modelConstructor(): new () => FabricDataflowLinkedService {
        return FabricDataflowLinkedService;
    }

    protected model(): IModel {
        return FabricDataflowLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(_linkedService: FabricDataflowLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        return linkedServiceResource;
    }
    
    protected async propertiesToModelAsync(_linkedServiceResource: Model.LinkedServiceResource, linkedService: FabricDataflowLinkedService): Promise<FabricDataflowLinkedService> {
        return linkedService;
    }
}
